<div class="container-fluid px-0 vh-100" data-bs-theme="dark">
  <canvas id="_confetti" class="canvas"></canvas>
  @if (lessonId) {
    @if (isNavigationVisible) {
      <ng-container [ngTemplateOutlet]="_closeButton"></ng-container>
    }
    <div class="lesson-complete-container row vh-100">
      <div class="col m-0" [ngClass]="rootClassName">
        <div class="row mx-auto max-width justify-content-center mt-5" [style.max-width]="'1280px'">
          <div class="col-11 col-md-7">
            <div class="text-center">
              <div class="row justify-content-center">
                <div class="col">
                  @if (isProgressBarVisible) {
                    <div class="progress">
                      <progressbar
                        class="progress-bar progress-bar-striped"
                        role="progressbar"
                        [ngStyle]="{
                          margin: 0,
                          width: maturityProgress | percent
                        }"
                        attr.aria-valuenow="{{ maturityProgress }}"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        title="{{ maturityProgress | percent }}"
                      ></progressbar>
                    </div>
                  }
                </div>
              </div>
              <div class="headingboldlarge fs-1 text-title">{{titleText}}</div>
              <div class="headingregularsmall text-subtitle">{{subtitleText}}</div>
              <div class="image-container">
                <img
                  [src]="imageURL | async"
                  alt="{{ lessonId }}"
                />
              </div>
            </div>
            <div class="col">
              <mat-divider class="divider-custom my-3"></mat-divider>
              <div class="d-flex flex-column text-white fs-4">
                <ng-container [ngTemplateOutlet]="_statrow" [ngTemplateOutletContext]="{id:'correctAnswer', icon:'check', title:'Correct Answers', value:answersRight, totalvalue:questions}"></ng-container>
                @if (retentionRate) { <ng-container [ngTemplateOutlet]="_statrow" [ngTemplateOutletContext]="{id:'memoryAccuracy', icon:'radar', title:'Memory Accuracy', rate:retentionRate}"></ng-container> }
                <ng-container [ngTemplateOutlet]="_statrow" [ngTemplateOutletContext]="{id:'duration', icon:'access_time', title:'Time Studied', value:time, options:studyTimeOptions}"></ng-container>
              </div>
              <mat-divider class="divider-custom my-3"></mat-divider>
              <div class="row mt-5">
                <div class="d-flex justify-content-center">
                  <button type="submit" class="btn btn-lg btn-custom rounded-5 me-2" (click)="onClose()">{{'Dashboard'}}</button>
                  @if(!isNavigationVisible) {
                    <button type="submit" class="btn btn-lg btn-custom rounded-5 ms-2" (click)="onClose('continue')">{{'Continue'}}</button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<div class="d-md-none frame100pxspacer"></div>

<ng-template #_statrow
  let-id="id"
  let-icon="icon"
  let-title="title"
  let-value="value"
  let-totalvalue="totalvalue"
  let-rate="rate"
  let-options="options"
>
  <div class="row mt-1 mb-2">
    <div class="col-auto align-self-center pt-1">
      <mat-icon aria-hidden="true" [style.color]="'#4ADAE7'" fontIcon="{{icon}}"></mat-icon>
    </div>
    <div class="col-auto align-self-center flex-fill labelmediumregular opacity-50">{{title}}</div>
    <div class="col-auto align-self-center">
      @if(value) {
        <label
          id="{{id}}"
          class="headingboldlarge"
          [countUp]="value"
          [options]="options??countUpOptions"
        ></label>
        @if(totalvalue) { <label class="labelmediumregular opacity-25">/{{ totalvalue }}</label> }
      }
      @else if (rate > 1) {
        <label
          id="{{id}}"
          class="headingboldlarge"
          [countUp]="rate"
        ></label>
        <label class="headingboldlarge">%</label>
      } @else {
        <label class="headingboldlarge">-</label>
      }
    </div>
  </div>
</ng-template>

<ng-template #_closeButton>
  <button
    type="button"
    class="btn-close position-fixed start-0 ms-2 mt-2"
    aria-label="Close"
    data-bs-dismiss="modal"
    (click)="onClose()"
  >
  </button>
</ng-template>
